import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ApiService } from 'src/app/services/api.service';

interface DialogData {
  billProof: string;
  billNumber: string;
}
@Component({
  selector: 'app-imagepreview',
  templateUrl: './imagepreview.component.html',
  styleUrls: ['./imagepreview.component.scss']
})
export class ImagepreviewComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ImagepreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData , private apiService: ApiService, private sanitizer:DomSanitizer,) {}
    imgSrc: SafeUrl | null = null;
  ngOnInit(): void {
    const imageUrl = "/hawdco/bills/"+ this.data.billNumber +"/proof"
   
    this.apiService.getBillProof(imageUrl).subscribe(blobData => {
      const unsafeImageUrl = URL.createObjectURL(blobData);
     this.imgSrc = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
     });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
